// extracted by mini-css-extract-plugin
export var promotionLink = "_w4-0";